import Link from 'next/link';

import LazyLoadImage from 'Components/shared/LazyLoadImage/LazyLoadImage';
import { MobilizeBadge } from 'Components/shared/MobilizeBadge';
import type { VehicleListItem } from 'Types/vehicle';
import { formatPrice } from 'Utilities/formatPrice';
import { formatVehicleName } from 'Utilities/formatters';
import ROUTES from 'Utilities/routes';

import styles from './MobilizeVehicleCard.module.scss';

const IMAGE_WIDTH = 320;
const IMAGE_HEIGHT = 240; // 4:3

export type MobilizeVehicleCardVehicle = Pick<
	VehicleListItem,
	'displayPrice' | 'id' | 'isVatQualifying' | 'leadPhoto' | 'make' | 'model'
>;

interface MobilizeVehicleCardProps {
	onClick?: () => void;
	vehicle: MobilizeVehicleCardVehicle;
}

export const MobilizeVehicleCard: React.FC<MobilizeVehicleCardProps> = ({ onClick, vehicle }) => {
	const { displayPrice, id, isVatQualifying, leadPhoto, make, model } = vehicle;

	return (
		<Link
			as={ROUTES.VEHICLE.as(id)}
			className={styles.card}
			href={`${ROUTES.VEHICLE.href}?vehicleId=${id}`}
			onClick={onClick}
		>
			<div className={styles.imageWrap}>
				<LazyLoadImage
					classNames={{ container: styles.imageContainer, image: styles.image }}
					height={IMAGE_HEIGHT}
					photo={leadPhoto}
					rootComponent="div"
					width={IMAGE_WIDTH}
				/>
				<MobilizeBadge />
			</div>
			<h3 className={styles.title}>{formatVehicleName({ make, model })}</h3>
			<div className={styles.subtitle}>
				<span aria-hidden="true" className={styles.status} />
				<span className={styles.price}>
					{formatPrice(displayPrice, false, 0)}
					{isVatQualifying ? ' +VAT' : ''}
				</span>
			</div>
		</Link>
	);
};
